import { getToken } from "../../utils/tokenUtils";
import {
  postRequest,
  getRequest,
  postRequestFile,
} from "../../config/AxiosConfig";
import API_URLS from "../../config/BackendConfig";

const prodBaseUrl = API_URLS.PROD;
const CusBaseUrl = API_URLS.CUSTOMER;

const getAuthHeaders = () => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Verify Bank Pennyless
export const verifyBankPennyless = async ({
  api_id,
  api_key,
  token_id,
  account_number,
  bank_ifsc,
  ifsc_details,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      account_number: account_number,
      bank_ifsc: bank_ifsc,
      ifsc_details: ifsc_details,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}bank-verification/pennyless`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error Bank Pennyless Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// Verify GST
export const verifyGSTIn = async ({ api_id, api_key, token_id, gstin }) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      gstin: gstin,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}verify/gstin`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error("Error GST Verify:", error.response?.data || error.message);
    throw error;
  }
};

// Verify Mob Bank
export const verifyMobileBank = async ({
  api_id,
  api_key,
  token_id,
  mobile_number,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      mobile_number: mobile_number,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}mobile-to-bank-details/verification`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error Mobile Bank Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// Verify Mob Bank
export const verifyMobileName = async ({
  api_id,
  api_key,
  token_id,
  mobile,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      mobile: mobile,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}srv2/mobile-name-finder`,
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    console.error(
      "Error Mobile Name Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// Verify Mob To WhatsUp
export const verifyMobileToWhatsUp = async ({
  api_id,
  api_key,
  token_id,
  mobileNumber,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      mobileNumber: mobileNumber,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}srv2/digital-profile/whatsapp-number-check`,
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    console.error(
      "Error Mobile Name Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

//  verifyMobileToUdyam
export const verifyMobileToUdyam = async ({
  api_id,
  api_key,
  token_id,
  mobile,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      mobile: mobile,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/kyb/mobile-to-udyam`,
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    console.error(
      "Error Mobile Name Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// {
//     "api_id": "APID0326",
//     "api_key": "82f16404-6233-4617-ba81-558481280608",
//     "token_id": "QE9PNYSsp05cPa8FAYsOmfiHY6ApFj7t",
//     "mobile": "9469612905",
//     "requested_services": [
//         "flipkart",
//         "amazon",
//         "paytm",
//         "facebook",
//         "instagram",
//         "twitter",
//         "linkedin",
//         "whatsapp"
//     ]
// }

// Mobile Check
export const verifyMobilecheck = async ({
  api_id,
  api_key,
  token_id,
  mobile,
  requested_services,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      mobile: mobile,
      requested_services: requested_services,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}srv2/digital-profile/mobile-check`,
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    console.error(
      "Error Mobile Name Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// Mobile to UPI Basic
export const verifyMobileToUPIBasic = async ({
  api_id,
  api_key,
  token_id,
  mobile_number,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      mobile_number: mobile_number,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}srv2/mobile-upi-lookup/basic`,
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    console.error(
      "Error Mobile Name Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// Mobile UPI Lookup Basic
export const verifyMobileUPILookupBasic = async ({
  api_id,
  api_key,
  token_id,
  mobile_number,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      mobile_number: mobile_number,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}srv2/mobile-upi-lookup/basic`,
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    console.error(
      "Error Mobile Name Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// Mobile UPI Lookup advance
export const verifyMobileUPILookupAdvance = async ({
  api_id,
  api_key,
  token_id,
  mobile_number,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      mobile_number: mobile_number,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}srv2/mobile-upi-lookup/advance`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error Mobile Name Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// Mobile UPI Lookup enhanced
export const verifyMobileUPILookupenhanced = async ({
  api_id,
  api_key,
  token_id,
  mobile_number,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      mobile_number: mobile_number,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}srv2/mobile-upi-lookup/enhanced`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error Mobile Name Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// Mobile Validation Basic
export const verifyMobileValidationBasic = async ({
  api_id,
  api_key,
  token_id,
  mobile_number,
  options,
}) => {
  try {
    const payload = {
      api_id,
      api_key,
      token_id,
      mobile_number,
      ...(options ? { options } : {}),
    };
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/mobile-number-validation`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      " Error verifying mobile number:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// Mobile Validation OTP

export const sendMobileOtpValidation = async ({
  api_id,
  api_key,
  token_id,
  mobile_number,
}) => {
  try {
    const payload = {
      api_id,
      api_key,
      token_id,
      mobile_number,
      method: "initial", // sending OTP
    };

    const response = await postRequest({
      url: `${prodBaseUrl}srv2/mobile-number-validation/otp-based`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(" Error sending OTP:", error.response?.data || error.message);
    throw error;
  }
};

// Mobile Validation OTP  Verify
export const verifyMobileOtpValidation = async ({
  api_id,
  api_key,
  token_id,
  txn_id,
  otp_value,
}) => {
  try {
    const payload = {
      api_id,
      api_key,
      token_id,
      txn_id,
      otp_value,
      method: "final", // Verify
    };

    const response = await postRequest({
      url: `${prodBaseUrl}srv2/mobile-number-validation/otp-based`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      " Error verifying OTP:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// Email Check
export const verifyEmailcheck = async ({
  api_id,
  api_key,
  token_id,
  email,
  requested_services,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      email: email,
      requested_services: requested_services,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}srv2/digital-profile/email-check`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error Mobile Name Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// Verify RC
export const verifyRC = async ({ api_id, api_key, token_id, rc_number }) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      rc_number: rc_number,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}vehicle/rc-verification`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error("Error RC Verify:", error.response?.data || error.message);
    throw error;
  }
};

// Verify PINCode

export const verifyPinCode = async ({ api_id, api_key, token_id, pincode }) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      pincode: pincode,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}pincode/verify`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error Pincode Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const VehicleVerifyRC2 = async ({
  api_id,
  api_key,
  token_id,
  rc_number,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      rc_number: rc_number,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}vehicle/rc-verification2`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error("Error RC Verify:", error.response?.data || error.message);
    throw error;
  }
};

// Verify DL
export const verifyDL = async ({
  api_id,
  api_key,
  token_id,
  id_number,
  dob,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      id_number: id_number,
      dob: dob,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}verify/driving-license`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error("Error DL Verify:", error.response?.data || error.message);
    throw error;
  }
};

// Verify Aadhar Pan Link
export const verifyAadharPanLink = async ({
  api_id,
  api_key,
  token_id,
  aadhar_number,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      aadhar_number: aadhar_number,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}check/aadhar-pan-link`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error Aadhar Pan Link Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// Verify Ration Card
export const verifyRationCard = async ({
  api_id,
  api_key,
  token_id,
  ration_card_number,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      ration_card_number: ration_card_number,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}verify/ration-card`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error Ration Card Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// Company CIN Verificatin
export const verifyCompanyCIN = async ({ api_id, api_key, token_id, cin }) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      cin: cin,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}verify/company-cin`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error("Error CIN Verify:", error.response?.data || error.message);
    throw error;
  }
};

// ITR Compliance
export const verifyITRCompliance = async ({
  api_id,
  api_key,
  token_id,
  pan_number,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      pan_number: pan_number,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}itr/compliance-check`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error ITR Compliance  Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const verifyKybRcValiationService = async (payload) => {
  try {
    let response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/rc`,
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const RCToChallanService = async (payload) => {
  try {
    let response = await postRequest({
      url: `${prodBaseUrl}srv3/rc/advance-challan-details`,
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const verifyKybRcReverseService = async (payload) => {
  try {
    let response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/reverse-rc-details`,
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const verifyRcPlusService = async (payload) => {
  try {
    let response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/rc-plus`,
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const verifyKybBaicGst = async (payload) => {
  try {
    let response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/kyb/gst`,
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    return error;
  }
};
export const verifyKybAdvancedGst = async (payload) => {
  try {
    let response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/kyb/gst-advance`,
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    return error;
  }
};
export const verifyKybContactToGstService = async (payload) => {
  try {
    let response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/kyb/contact-to-gst`,
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const verifyKybGstToContactService = async (payload) => {
  try {
    let response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/kyb/gst-to-contacts`,
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    return error;
  }
};

// 1)
// {
//     "api_id": "APID0326",
//     "api_key": "82f16404-6233-4617-ba81-558481280608",
//     "token_id": "QE9PNYSsp05cPa8FAYsOmfiHY6ApFj7t",
//     "method": "INITIATE_UPLOAD",
//     "acceptance_policy": "atLeastOneTransactionInRange"
// }
// 2)
// {
//     "api_id": "APID0326",
//     "api_key": "82f16404-6233-4617-ba81-558481280608",
//     "token_id": "QE9PNYSsp05cPa8FAYsOmfiHY6ApFj7t",
//     "token": "etgerterter",
//     "method": "UPLOAD",
//     "request_id": "65654",
//     "files": ""
// 3)
// {
//     "api_id": "APID0326",
//     "api_key": "82f16404-6233-4617-ba81-558481280608",
//     "token_id": "QE9PNYSsp05cPa8FAYsOmfiHY6Ap
//     "method": "COMPLETE_UPLOAD",
//     "request_id":""
// 4)
// {
//     "api_id": "APID0326",
//     "api_key": "82f16404-6233-4617-ba81-558481280608",
//     "token_id": "QE9PNYSsp05cPa8FAYsOmfiHY6ApFj7t",
//     "method": "CHECK_STATUS",
//     "request_id":""
// }

// 5)
// {
//     "api_id": "APID0326",
//     "api_key": "82f16404-6233-4617-ba81-558481280608",
//     "token_id": "QE9PNYSsp05cPa8FAYsOmfiHY6ApFj7t",
//     "method": "RETRIEVE_STATEMENT",
//     "txn_id":"",
//     "report_type":"json,xlsx",
//     "report_subtype":"type1,type2,type3" // for xlsx only type3 applicable for json choose any
// 6)
// {
//     "api_id": "APID0326",
//     "api_key": "82f16404-6233-4617-ba81-558481280608",
//     "token_id": "QE9PNYSsp05cPa8FAYsOmfiHY6ApFj7t",
//     "method": "CANCEL_REQUEST",
//     "request_id":"196744"
// }

export const StatementAnalyzerService = async (payload) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/statement-analyzer`,
      headers: {
        ...getAuthHeaders(),
        "Content-Type": "multipart/form-data",
      },
      data: payload,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// {
//     "from_date":"",
//     "to_date":"",
//     "total_data":"2"
// }
export const StatementReportService = async (payload) => {
  try {
    const response = await postRequest({
      url: `${CusBaseUrl}fetch-statement-analysis`,
      headers: {
        ...getAuthHeaders(),
        "Content-Type": "multipart/form-data",
      },
      data: payload,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// Verify Face

export const verifyFaceAPI = async ({
  api_id,
  api_key,
  token_id,
  personFile,
  cardFile,
}) => {
  try {
    const formData = new FormData();

    formData.append("api_id", api_id);
    formData.append("api_key", api_key);
    formData.append("token_id", token_id);

    // BOTH must be FILES
    formData.append("person", personFile);
    formData.append("card", cardFile);

    const response = await postRequest({
      url: `${prodBaseUrl}srv2/face-api/match`,
      headers: {
        ...getAuthHeaders(),
        // axios will auto set boundary
        "Content-Type": "multipart/form-data",
      },
      data: formData,
    });

    return response;
  } catch (error) {
    console.error(
      "Error FaceAPI Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// Verify Face

export const verifyLivenessAPI = async ({
  api_id,
  api_key,
  token_id,
  personFile,
}) => {
  try {
    const formData = new FormData();

    formData.append("api_id", api_id);
    formData.append("api_key", api_key);
    formData.append("token_id", token_id);

    // BOTH must be FILES
    formData.append("person", personFile);

    const response = await postRequest({
      url: `${prodBaseUrl}srv2/face-api/liveness`,
      headers: {
        ...getAuthHeaders(),
        // axios will auto set boundary
        "Content-Type": "multipart/form-data",
      },
      data: formData,
    });

    return response;
  } catch (error) {
    console.error(
      "Error FaceAPI Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// face detection
export const verifyFaceDetectionAPI = async ({
  api_id,
  api_key,
  token_id,
  personFile,
}) => {
  try {
    const formData = new FormData();

    formData.append("api_id", api_id);
    formData.append("api_key", api_key);
    formData.append("token_id", token_id);

    // BOTH must be FILES
    formData.append("imageUrl", personFile);

    const response = await postRequest({
      url: `${prodBaseUrl}srv2/face-api/detection`,
      headers: {
        ...getAuthHeaders(),
        // axios will auto set boundary
        "Content-Type": "multipart/form-data",
      },
      data: formData,
    });

    return response;
  } catch (error) {
    console.error(
      "Error Face Detection Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// pan details v1
export const verifyPanDetailsV1 = async ({
  api_id,
  api_key,
  token_id,
  pan,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      pan: pan,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/pan/father-details`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error Pan Details V1 Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// pan to father details
export const verifyPanToFatherDetails = async ({
  api_id,
  api_key,
  token_id,
  pan,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      pan: pan,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/pan/to-father-name`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error Pan Details V1 Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// pan basic details
export const verifyPanBasicDetails = async ({
  api_id,
  api_key,
  token_id,
  pan,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      pan: pan,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/pan/basic`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error Pan Details V1 Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// pan details v2
export const verifyPanDetailsV2 = async ({
  api_id,
  api_key,
  token_id,
  pan,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      pan: pan,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/pan`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error Pan Details V2 Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const verifyPanProfile = async ({ api_id, api_key, token_id, pan }) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      pan: pan,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/pan/profile`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error Pan Details V2 Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const verifyDinToContact = async ({
  api_id,
  api_key,
  token_id,
  din,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      din: din,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}srv3/din/director-phone-number`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error Din to Contact Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const verifyRcToMobileDetails = async ({
  api_id,
  api_key,
  token_id,
  regNo,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      reg_number: regNo,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}srv3/rc/to-mobile`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error Rc To Mobile Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const verifyAdvanceChallanDetails = async ({
  api_id,
  api_key,
  token_id,
  regNo,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      reg_number: regNo,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}srv3/rc/challan-details`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error Advance Challan Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// verify rc to challan details
export const verifyRcToChallanDetails = async ({
  api_id,
  api_key,
  token_id,
  regNo,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      reg_number: regNo,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}srv3/rc/challan-details`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error Advance Challan Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// verify aadhar details without otp
export const verifyAadharDetails = async ({
  api_id,
  api_key,
  token_id,
  aadhaar,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      aadhaar: aadhaar,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}srv3/verification/aadhar`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error in Aadhar Details Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

// verify bank details penny drop
export const verifyBankDetailsPennyDrop = async ({
  api_id,
  api_key,
  token_id,
  accountId,
  ifscCode,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      creditorAccountId: accountId,
      ifscCode: ifscCode,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}bank-verification/penny-drop`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error in Verifying Bank Details Penny Drop:",
      error.response.data || error.message,
    );
    throw error;
  }
};

// verify bank details benny validation
export const verifyBankBennyValidation = async ({
  api_id,
  api_key,
  token_id,
  accountId,
  ifscCode,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      creditorAccountId: accountId,
      ifscCode: ifscCode,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}idfc/beneficiary`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error in Benny Validation:",
      error?.response?.data || error?.message,
    );
    throw error;
  }
};

export const verifyAadharToPanDetails = async ({
  api_id,
  api_key,
  token_id,
  aadharNo,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      aadhaar: aadharNo,
      type: 1,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}srv3/verification/aadhar-to-pan`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error in verify Aadhar To Pan Details:",
      error?.data?.message || error?.message,
    );
    throw error;
  }
};

// verify rc
export const verifyRcDetails = async ({ api_id, api_key, token_id, regNo }) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      reg_number: regNo,
      cache_days: "0",
      type: 1,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}srv3/rc/verification`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error in verify Rc Details:",
      error?.data?.message || error?.message,
    );
    throw error;
  }
};

// verify rc advance
export const verifyRcAdvanceDetails = async ({
  api_id,
  api_key,
  token_id,
  regNo,
}) => {
  try {
    const paylaod = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      reg_number: regNo,
      cache_days: "0",
      type: 1,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}srv3/rc/advance-verification`,
      headers: getAuthHeaders(),
      data: paylaod,
    });

    return response;
  } catch (error) {
    console.error(
      "Error in verify Rc Advance Details :",
      error?.response?.message || error?.message,
    );
    throw error;
  }
};

// verify peenydrop advance
export const verifyPennyDropAdvance = async ({
  api_id,
  api_key,
  token_id,
  accountId,
  ifscCode,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      creditorAccountId: accountId,
      ifscCode: ifscCode,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}bank-verification/penny-drop-advance`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error in Verify Peeny Drop Advance",
      error?.data?.message || error?.message,
    );
    throw error;
  }
};

// verify pennyless advance
export const verifyPennyLessAdvance = async ({
  api_id,
  api_key,
  token_id,
  accountId,
  ifscCode,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      creditorAccountId: accountId,
      ifscCode: ifscCode,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}bank-verification/penny-less-advance`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error in Verify Penny Less Advance :",
      error?.data?.message || error?.message,
    );
    throw error;
  }
};

// verify ifsc code
export const verifyIfscCode = async ({
  api_id,
  api_key,
  token_id,
  ifscCode,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      ifsccode: ifscCode,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}ifsc/verify`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error in Verify Ifsc Code:",
      error?.data?.message || error?.message,
    );
    throw error;
  }
};

// verify din to pan details
export const verifyDinToPanDetails = async ({
  api_id,
  api_key,
  token_id,
  dinNo,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      din: dinNo,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/kyb/din-to-pan`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error in verify Din To Pan Details: ",
      error?.data?.message || error?.message,
    );
    throw error;
  }
};

// verify pan to din details
export const verifyPanToDinDetails = async ({
  api_id,
  api_key,
  token_id,
  pan,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      pan: pan,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/kyb/pan-to-din`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error in Verify Pan To Din Details:",
      error?.data?.message || error?.message,
    );
    throw error;
  }
};

// verify gst-pan-search
export const verifyGstPanSearch = async ({
  api_id,
  api_key,
  token_id,
  pan,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      pan: pan,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/kyb/gst-pan-search`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error in Verify Gst Pan Search :",
      error?.data?.messgae || error?.message,
    );
    throw error;
  }
};

export const verifyDigitalKyc = async (payload) => {
  try {
    // const payload = {
    //   api_id: api_id,
    //   api_key: api_key,
    //   token_id: token_id,
    //   methodName: methodName,
    //   redirectUrl: redirectedURL,
    //   logoUrl: logoUrl,
    //   mobile_number: ""
    // };

    const response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/digilocker-digital-kyc`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error in Verify Digital Kyc :",
      error?.data?.messgae || error?.message,
    );
    throw error;
  }
};

export const fetchDigitalKycData = async ({
  api_id,
  api_key,
  token_id,
  client_id,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      methodName: "fetchDetails",
      client_id: client_id,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/digilocker-digital-kyc`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error in Verify Digital Kyc :",
      error?.data?.messgae || error?.message,
    );
    throw error;
  }
};

export const dinToContact = async ({
  api_id,
  api_key,
  token_id,
  din,
  consent,
}) => {
  const payload = {
    api_id: api_id,
    api_key: api_key,
    token_id: token_id,
    din: din,
    consent: consent,
  };

  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/din/to-contact`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const verifyConsumerDetails = async ({
  api_id,
  api_key,
  token_id,
  mobile_number,
  first_name,
  last_name,
}) => {
  const payload = {
    api_id,
    api_key,
    token_id,
    mobile_number,
    first_name,
    last_name,
  };

  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/credit-report/consumer-details`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};
export const fetchProfileDetails = async ({
  api_id,
  api_key,
  token_id,
  mobile_number,
  first_name,
  last_name,
}) => {
  const payload = {
    api_id,
    api_key,
    token_id,
    mobile_number,
    first_name,
    last_name,
  };

  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/profile-fetch`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};
export const verifyPrefillDetails = async ({
  api_id,
  api_key,
  token_id,
  mobile,
  name,
}) => {
  const payload = {
    api_id,
    api_key,
    token_id,
    mobile,
    name,
  };

  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/credit-report/prefill`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const verifyPrefillv2Details = async ({
  api_id,
  api_key,
  token_id,
  mobile,
  first_name,
  middle_name,
  last_name,
}) => {
  const payload = {
    api_id,
    api_key,
    token_id,
    mobile,
    first_name,
    middle_name,
    last_name,
  };

  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv3/credit-report/prefill`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const verifyPrefillv3Details = async ({
  api_id,
  api_key,
  token_id,
  mobile,
}) => {
  const payload = {
    api_id,
    api_key,
    token_id,
    mobile,
  };

  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv3/credit-report/prefill-wn`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};
export const verifyPrefillv4Details = async ({
  api_id,
  api_key,
  token_id,
  mobile,
}) => {
  const payload = {
    api_id,
    api_key,
    token_id,
    mobile_number: mobile,
  };

  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv4/credit-report/prefill`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const verifyRcCardDetails = async ({
  api_id,
  api_key,
  token_id,
  reg_number,
}) => {
  const payload = {
    api_id,
    api_key,
    token_id,
    reg_number,
  };

  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv3/rc/card`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const verifyViewConsent = async () => {
  try {
    const response = await getRequest({
      url: `${CusBaseUrl}consent/view`,
      headers: getAuthHeaders(),
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};
export const verifyAcceptConsent = async (msgId) => {
  try {
    const response = await postRequest({
      url: `${CusBaseUrl}consent/accept`,
      headers: getAuthHeaders(),
      data: {
        consent_message_id: msgId,
      },
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const verifyAcceptedConsent = async (msgId) => {
  try {
    const response = await postRequest({
      url: `${CusBaseUrl}consent/accepted`,
      headers: getAuthHeaders(),
      data: {
        consent_message_id: msgId,
      },
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const verifyMobileToBankBasic = async ({
  api_id,
  api_key,
  token_id,
  mobileNumber,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      mobile: mobileNumber,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}srv2/mobile-to-masked-bank/basic`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error Mobile Bank Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const MobileToBankAjvance = async ({
  api_id,
  api_key,
  token_id,
  mobile,
}) => {
  try {
    const payload = {
      api_id: api_id,
      api_key: api_key,
      token_id: token_id,
      mobile: mobile,
    };

    const response = await postRequest({
      url: `${prodBaseUrl}srv2/mobile-to-masked-bank/advance`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error Mobile Bank Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const DinBulkUploading = async (formData) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}bulk-din/upload`,
      data: formData,
      headers: {
        ...getAuthHeaders(),
        "Content-Type": "multipart/form-data",
      },
    });

    return response;
  } catch (error) {
    console.error(
      "Bulk DIN Upload Error:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const DinBulkDownloading = async ({
  api_id,
  api_key,
  token_id,
  reference_id,
}) => {
  const payload = {
    api_id,
    api_key,
    token_id,
    reference_id,
  };
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}bulk-din/download`,
      data: payload,
      headers: getAuthHeaders(),
    });

    return response;
  } catch (error) {
    console.error(
      "Bulk DIN Upload Error:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const GetBulkReportDin = async (paylaod) => {
  try {
    const response = await postRequest({
      url: `${CusBaseUrl}bulk-service/din`,
      data: paylaod,
      headers: getAuthHeaders(),
    });

    return response;
  } catch (error) {
    console.error(
      "Bulk DIN Upload Error:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const ocrAadhar = async (formData) => {
  try {
    const response = await postRequestFile({
      url: `${prodBaseUrl}ocr/aadhar`,
      headers: getAuthHeaders(),
      data: formData,
    });

    return response;
  } catch (error) {
    console.error(
      "Error Ocr Aadhar Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const ocrPan = async (formData) => {
  try {
    const response = await postRequestFile({
      url: `${prodBaseUrl}ocr/pan`,
      headers: getAuthHeaders(),
      data: formData,
    });

    return response;
  } catch (error) {
    console.error(
      "Error Ocr Pan Verify:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const GstBulkUploading = async (formData) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}bulk-gstin/upload`,
      data: formData,
      headers: {
        ...getAuthHeaders(),
        "Content-Type": "multipart/form-data",
      },
    });

    return response;
  } catch (error) {
    console.error(
      "Bulk DIN Upload Error:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const GstBulkDownloading = async ({
  api_id,
  api_key,
  token_id,
  reference_id,
}) => {
  const payload = {
    api_id,
    api_key,
    token_id,
    reference_id,
  };
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}bulk-gstin/download`,
      data: payload,
      headers: getAuthHeaders(),
    });

    return response;
  } catch (error) {
    console.error(
      "Bulk DIN Upload Error:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const GetGstBulkReport = async (paylaod) => {
  try {
    const response = await postRequest({
      url: `${CusBaseUrl}bulk-service/gstin`,
      data: paylaod,
      headers: getAuthHeaders(),
    });

    return response;
  } catch (error) {
    console.error(
      "Bulk DIN Upload Error:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const verifyPanToCinDetails = async ({
  api_id,
  api_key,
  token_id,
  pan,
}) => {
  const payload = {
    api_id,
    api_key,
    token_id,
    pan,
  };

  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/kyb/pan-to-cin `,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const verifyPanToContact = async ({
  api_id,
  api_key,
  token_id,
  pan,
}) => {
  const payload = {
    api_id,
    api_key,
    token_id,
    pan,
  };
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/pan/to-contact`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};
export const verifyPanToBankAccount = async ({
  api_id,
  api_key,
  token_id,
  pan,
}) => {
  try {
    const payload = {
      api_id,
      api_key,
      token_id,
      pan,
    };
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/pan/to-bank-account`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const companyCinService = async ({ payload }) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}verify/basic-company-cin`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    throw error;
  }
};
export const verifyOcrPassport = async (formData) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}ocr/passport`,
      headers: {
        ...getAuthHeaders(),
        "Content-Type": "multipart/form-data",
      },
      data: formData,
    });

    return response;
  } catch (error) {
    throw error;
  }
};

export const verifyOcrVoter = async (formData) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}ocr/voter `,
      headers: {
        ...getAuthHeaders(),
        "Content-Type": "multipart/form-data",
      },
      data: formData,
    });

    return response;
  } catch (error) {
    throw error;
  }
};
export const verifyOcrDl = async (formData) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}ocr/dl `,
      headers: {
        ...getAuthHeaders(),
        "Content-Type": "multipart/form-data",
      },
      data: formData,
    });

    return response;
  } catch (error) {
    throw error;
  }
};

export const verifyOcrGenericKYC = async (formData) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}ocr/generic-kyc-detection`,
      headers: {
        ...getAuthHeaders(),
        "Content-Type": "multipart/form-data",
      },
      data: formData,
    });

    return response;
  } catch (error) {
    throw error;
  }
};

export const verifyDrivingLicence = async ({
  api_id,
  api_key,
  token_id,
  dl,
}) => {
  const payload = {
    api_id,
    api_key,
    token_id,
    license_number: dl,
  };

  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv3/verification/driving-licenses`,
      headers: getAuthHeaders(),

      data: payload,
    });

    return response;
  } catch (error) {
    throw error;
  }
};

export const verifyRcDetailsFull = async ({
  api_id,
  api_key,
  token_id,
  rc,
}) => {
  const payload = {
    api_id,
    api_key,
    token_id,
    rc_number: rc,
  };

  try {
    const response = await postRequest({
      url: `${prodBaseUrl}vehicle/rc-verification-full`,
      headers: getAuthHeaders(),

      data: payload,
    });

    return response;
  } catch (error) {
    throw error;
  }
};

export const verifyUpiAdvance = async ({
  api_id,
  api_key,
  token_id,
  upi_id,
}) => {
  const payload = {
    api_id,
    api_key,
    token_id,
    upi_id,
  };

  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/upi-verification/advance `,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const verifyUpiSimple = async ({
  api_id,
  api_key,
  token_id,
  upi_id,
}) => {
  const payload = {
    api_id,
    api_key,
    token_id,
    upi_id,
  };

  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/upi-verification/simple `,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const generateOvseQr = async (payload) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}ovse/generate-qr`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getOvseStatus = async (payload) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}ovse/status`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getChallanProDetails = async (payload) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv4/challan-pro`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getFastagBalance = async (payload) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv1/fastag-balance`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getRcProDetails = async (payload) => {
  try {
    const res = await postRequest({
      url: `${prodBaseUrl}srv3/rc-pro`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const getChasisToRcDetails = async (payload) => {
  try {
    const res = await postRequest({
      url: `${prodBaseUrl}srv1/chassis-to-rc`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const getFastagTxnDetails = async (payload) => {
  try {
    const res = await postRequest({
      url: `${prodBaseUrl}srv1/fastag-txn`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const getMobileToRcDetails = async (payload) => {
  try {
    const res = await postRequest({
      url: `${prodBaseUrl}srv1/mobile-to-rc`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const getRcToMobileSrv1 = async (payload) => {
  try {
    const res = await postRequest({
      url: `${prodBaseUrl}srv1/rc-to-mobile`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const getEngineToRcDetails = async (payload) => {
  try {
    const res = await postRequest({
      url: `${prodBaseUrl}srv1/engine-to-rc`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const getVehicleValuationPro = async (payload) => {
  try {
    const res = await postRequest({
      url: `${prodBaseUrl}srv1/valuation-pro`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const verifyVehicleRcLite = async (payload) => {
  try {
    const res = await postRequest({
      url: `${prodBaseUrl}srv3/rc-lite`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const verifyVehicleRcLogs = async (payload) => {
  try {
    const res = await postRequest({
      url: `${prodBaseUrl}srv1/rc-logs`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const verifyVehiclePuccPro = async (payload) => {
  try {
    const res = await postRequest({
      url: `${prodBaseUrl}srv3/pucc-pro`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const verifyVehicleExShowroom = async (payload) => {
  try {
    const res = await postRequest({
      url: `${prodBaseUrl}srv3/ex-showroom`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const verifyVehicleInsurancePro = async (payload) => {
  try {
    const res = await postRequest({
      url: `${prodBaseUrl}srv3/insurance-pro`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const getFastagStatus = async (payload) => {
  try {
    const res = await postRequest({
      url: `${prodBaseUrl}srv1/fastag-status`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const getVehicleFastagMapper = async (payload) => {
  try {
    const res = await postRequest({
      url: `${prodBaseUrl}srv1/fastag-mapper`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};
export const getDlLicence = async (payload) => {
  try {
    const res = await postRequest({
      url: `${prodBaseUrl}srv1/dl-license`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const getBasicEChallan = async (payload) => {
  try {
    const res = await postRequest({
      url: `${prodBaseUrl}srv2/basic-e-challan`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const uploadBulkRc = async ({ api_id, api_key, token_id, file }) => {
  const formData = new FormData();

  formData.append("api_id", api_id);
  formData.append("api_key", api_key);
  formData.append("token_id", token_id);
  formData.append("file", file);

  try {
    const res = await postRequest({
      url: `${prodBaseUrl}bulk-rc-to-mobile/upload`,
      headers: {
        ...getAuthHeaders(),
        "Content-Type": "multipart/form-data",
      },
      data: formData,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const downloadBulkRc = async ({
  api_id,
  api_key,
  token_id,
  reference_id,
}) => {
  const payload = { api_id, api_key, token_id, reference_id };
  try {
    const res = await postRequest({
      url: `${prodBaseUrl}bulk-rc-to-mobile/download`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const GetBulkReportRC = async (paylaod) => {
  try {
    const response = await postRequest({
      url: `${CusBaseUrl}bulk-service/rcin`,
      data: paylaod,
      headers: getAuthHeaders(),
    });

    return response;
  } catch (error) {
    console.error(
      "Bulk DIN Upload Error:",
      error.response?.data || error.message,
    );
    throw error;
  }
};
export const uploadBulkPan = async ({ api_id, api_key, token_id, file }) => {
  const formData = new FormData();

  formData.append("api_id", api_id);
  formData.append("api_key", api_key);
  formData.append("token_id", token_id);
  formData.append("file", file);

  try {
    const res = await postRequest({
      url: `${prodBaseUrl}srv2/bulk-pan-to-contact/upload`,
      headers: {
        ...getAuthHeaders(),
        "Content-Type": "multipart/form-data",
      },
      data: formData,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const downloadBulkPan = async ({
  api_id,
  api_key,
  token_id,
  reference_id,
}) => {
  const payload = { api_id, api_key, token_id, reference_id };
  try {
    const res = await postRequest({
      url: `${prodBaseUrl}srv2/bulk-pan-to-contact/download`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const getBukReportPan = async (paylaod) => {
  try {
    const response = await postRequest({
      url: `${CusBaseUrl}bulk-service/panToContact`,
      data: paylaod,
      headers: getAuthHeaders(),
    });

    return response;
  } catch (error) {
    console.error(
      "Bulk DIN Upload Error:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const verifyUanMobile = async ({
  api_id,
  api_key,
  token_id,
  mobile,
  pan,
}) => {
  const payload = {
    api_id,
    api_key,
    token_id,
    mobile,
    pan,
  };

  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/uan-mobile`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const verifyUanMobilesrv3 = async ({
  api_id,
  api_key,
  token_id,
  mobile,
}) => {
  const payload = {
    api_id,
    api_key,
    token_id,
    mobile,
  };

  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv3/uan-mobile`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const verifyUanPan = async ({ api_id, api_key, token_id, pan }) => {
  const payload = {
    api_id,
    api_key,
    token_id,
    pan,
  };

  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv3/uan-pan`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const verifyUanNameDob = async ({
  api_id,
  api_key,
  token_id,
  employee_name,
  dob,
}) => {
  const payload = {
    api_id,
    api_key,
    token_id,
    employee_name,
    dob,
  };

  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/uan-name-dob`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const verifyUanDirect = async ({ api_id, api_key, token_id, uan }) => {
  const payload = {
    api_id,
    api_key,
    token_id,
    uan,
  };

  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/uan-direct`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const verifyUanDirectSrv3 = async ({
  api_id,
  api_key,
  token_id,
  uan,
}) => {
  const payload = {
    api_id,
    api_key,
    token_id,
    uan,
  };

  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv3/uan-direct`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const verifyUanPanMobileSrv3 = async ({
  api_id,
  api_key,
  token_id,
  pan,
}) => {
  const payload = {
    api_id,
    api_key,
    token_id,
    pan,
  };

  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv3/uan-pan-mobile`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const verifyAadhharToPanUnmasked = async ({
  api_id,
  api_key,
  token_id,
  aadhaar,
}) => {
  const payload = {
    api_id,
    api_key,
    token_id,
    aadhar: aadhaar,
  };

  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/aadhaar-to-unmasked-pan`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};
export const verifyBasicGst = async ({ api_id, api_key, token_id, gstin }) => {
  const payload = {
    api_id,
    api_key,
    token_id,
    gstin,
  };

  try {
    const response = await postRequest({
      url: `${prodBaseUrl}gst-verify/basic`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const verifyChessisToRcV2 = async (payload) => {

  try {
    const response = await postRequest({
      url: `${prodBaseUrl}chassis-to-rc-detailsV2`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const verifyKycPanDetails = async ({
  api_id,
  api_key,
  token_id,
  pan,
}) => {
  const payload = {
    api_id,
    api_key,
    token_id,
    pan,
  };

  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/kyc/pan-details`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const verifyUpiBasicV2 = async ({
  api_id,
  api_key,
  token_id,
  upi_id,
}) => {
  const payload = {
    api_id,
    api_key,
    token_id,
    upi_id,
  };

  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/upi-verification/simple`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const verifyChallanProImage = async (payload) => {
  try {
    const res = await postRequest({
      url: `${prodBaseUrl}srv1/challan-pro-image`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};
export const verifyVehicleHistory = async (payload) => {
  try {
    const res = await postRequest({
      url: `${prodBaseUrl}srv3/vehicle-service-history`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const verifyPennyDropCheckValidation = async ({
  api_id,
  api_key,
  token_id,
  ifsc,
  accNo,
  benificiaryName,
}) => {
  const payload = {
    api_id,
    api_key,
    token_id,
    ifsc,
    accNo,
    benificiaryName,
  };

  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/peeny-drop/check-validation`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const verifyPennyLessCheckValidation = async ({
  api_id,
  api_key,
  token_id,
  ifsc,
  accNo,
  benificiaryName,
}) => {
  const payload = {
    api_id,
    api_key,
    token_id,
    ifsc,
    accNo,
    benificiaryName,
  };

  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/peeny-less/check-validation`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const verifyPennyUpiCheckValidation = async ({
  api_id,
  api_key,
  token_id,
  ifsc,
  accNo,
  benificiaryName,
}) => {
  const payload = {
    api_id,
    api_key,
    token_id,
    ifsc,
    accNo,
    benificiaryName,
  };

  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/peeny-upi-penny/check-validation`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getEwayBillV2Details = async (payload) => {
 
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/EwayBill/verify`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getProfileFetchV2Details = async (payload) => {
 
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}profile-fetch-DetailsV2`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getMobileToUpiAdvanceSrv2Details = async (payload) => {
 
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/mobile-to-upi-advance`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const verifyFIR = async (payload) => {
 
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}check/FIR`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.log(error);
  }
};
